var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletHomePage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.125 41.5C83.125 30.4935 78.7527 19.9378 70.9699 12.1551C63.1872 4.37231 52.6315 8.30967e-07 41.625 0C30.6185 -8.30966e-07 20.0628 4.37231 12.2801 12.1551C4.49731 19.9378 0.125002 30.4935 0.125 41.5L1.785 41.5C1.785 30.9338 5.98242 20.8003 13.4539 13.3289C20.9253 5.85741 31.0588 1.66 41.625 1.66C52.1912 1.66 62.3247 5.85742 69.7961 13.3289C77.2676 20.8003 81.465 30.9338 81.465 41.5H83.125Z",
    fill: "url(#paint0_linear_3495:38703)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3495:38703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.2812 40.1599V35.444C59.2812 33.1271 57.4377 31.2338 55.1406 31.1511V28.2565C55.1406 26.7488 53.914 25.5221 52.4062 25.5221H44.8783L43.9062 22.82C43.6583 22.131 43.1566 21.5803 42.4934 21.2696C41.8303 20.9588 41.0861 20.9257 40.398 21.1762L26.7375 26.1481C26.0502 26.3983 25.5018 26.9013 25.1934 27.5646C24.8849 28.2279 24.8536 28.9714 25.1052 29.6583L25.6541 31.1563C23.4091 31.2952 21.625 33.1647 21.625 35.444V56.694C21.625 59.0633 23.5526 60.9909 25.9219 60.9909H54.9844C57.3537 60.9909 59.2812 59.0633 59.2812 56.694V51.8219C60.6045 51.6317 61.625 50.491 61.625 49.1159V42.8659C61.625 41.4908 60.6045 40.35 59.2812 40.1599V40.1599ZM59.2812 49.1159C59.2812 49.3313 59.106 49.5065 58.8906 49.5065H52.6406C50.7021 49.5065 49.125 47.9294 49.125 45.9909C49.125 44.0524 50.7021 42.4753 52.6406 42.4753H58.8906C59.106 42.4753 59.2812 42.6505 59.2812 42.8659V49.1159ZM27.3059 28.852C27.2574 28.7196 27.293 28.6078 27.3185 28.5529C27.3441 28.4981 27.4066 28.3988 27.5391 28.3506L41.1996 23.3786C41.3323 23.3304 41.4441 23.3663 41.499 23.392C41.5539 23.4177 41.653 23.4806 41.7008 23.6135L42.3875 25.5222H41.8594C40.3516 25.5222 39.125 26.7488 39.125 28.2566V31.1472H28.1468L27.3059 28.852ZM52.7969 28.2565V31.1471H41.4688V28.2565C41.4688 28.0411 41.644 27.8659 41.8594 27.8659H52.4062C52.6216 27.8659 52.7969 28.0411 52.7969 28.2565V28.2565ZM54.9844 58.6471H25.9219C24.8449 58.6471 23.9688 57.771 23.9688 56.694V35.444C23.9688 34.367 24.8449 33.4909 25.9219 33.4909H54.9844C56.0613 33.4909 56.9375 34.367 56.9375 35.444V40.1315H52.6406C49.4098 40.1315 46.7812 42.76 46.7812 45.9909C46.7812 49.2217 49.4098 51.8503 52.6406 51.8503H56.9375V56.694C56.9375 57.771 56.0613 58.6471 54.9844 58.6471Z",
    fill: "url(#paint1_linear_3495:38703)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6406 47.1621C53.2878 47.1621 53.8125 46.6374 53.8125 45.9902C53.8125 45.343 53.2878 44.8184 52.6406 44.8184C51.9934 44.8184 51.4688 45.343 51.4688 45.9902C51.4688 46.6374 51.9934 47.1621 52.6406 47.1621Z",
    fill: "url(#paint2_linear_3495:38703)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3495:38703",
    x1: 1.16622,
    y1: 61.0974,
    x2: 83.1621,
    y2: 60.9846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BBBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3495:38703",
    x1: 22.1268,
    y1: 50.4404,
    x2: 61.6429,
    y2: 50.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BBBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3495:38703",
    x1: 51.4982,
    y1: 46.5436,
    x2: 53.8135,
    y2: 46.5404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BBBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3495:38703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(21.625 21)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletHomePage);
export default __webpack_public_path__ + "static/media/walletHomePage.c877ebce.svg";
export { ForwardRef as ReactComponent };